<template>
  <div class="box">
    <div class="main-content" v-if="types === 1">
      <div class="gandtxt1"></div>
      <div v-show="editableOrNot" class="gandtxt2">
        <img v-if="identity != 'teacher'" class="gandtxt_img2_1 btns" src="../../assets/classManagement/cm1.png" />
        <p v-if="identity != 'teacher'" class="gandtxt_txt2 btns" @click="add_classes1()">新增班级导入</p>
        <img class="gandtxt_img2_2 btns" src="../../assets/classManagement/cm2.png" />
        <p class="gandtxt_txt2 btns" @click="add_classes2()">从班级库新增</p>
      </div>
      <el-table class="gandtable" :header-cell-style="{ background: '#EEEEEE', color: '#000000' }"
        :data="classTableData" border>
        <el-table-column align="center" label="年级" prop="grade"></el-table-column>
        <el-table-column align="center" label="班级" prop="name"></el-table-column>
        <el-table-column align="center" label="查看详情">
          <template slot-scope="scope"><img class="gandtable_btn1 btns" src="../../assets/classManagement/cm3.png"
              @click="classViewDetails(scope.row)" /></template>
        </el-table-column>
        <el-table-column v-if="editableOrNot" align="center" label="删除">
          <template slot-scope="scope"><img class="gandtable_btn2 btns" src="../../assets/classManagement/cm4.png"
              @click="deleteClass(scope.row.id)" /></template>
        </el-table-column>
      </el-table>
      <!-- 新增班级导入部分开始 -->
      <div class="add_class" v-if="add_classVisible">
        <div class="add_classbg"></div>
        <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.7)" class="add_classdiv">
          <p class="add_classtxt">新增班级</p>
          <img class="div_close btns" src="../../assets/classManagement/cm5.png" @click="add_classVisible = false" />
          <img @click="templateDownload" class="add_classtemp btns" src="../../assets/classManagement/cm6.png" />
          <div class="add_classinput" style="margin-top: 53px">
            <img class="add_classinput_img" src="../../assets/classManagement/cm8.png" />
            <img class="add_classbtn" src="../../assets/classManagement/cm9.png" />
            <p class="add_classinput_txt">对应年级：</p>
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopoverGrade">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in gradeDataList" :key="index"
                  v-model="checkGradeList">
                  <van-checkbox @click="changeCheckbox(item)" :name="item">{{ item }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <input class="add_classinput_inp" @click="showPopoverGrade = true" v-model="checkGradeList"
                  placeholder="请选择对应年级" />
              </template>
            </van-popover>
          </div>
          <div class="add_classinput">
            <img class="add_classinput_img" src="../../assets/classManagement/cm8.png" />
            <p class="add_classinput_txt">班级名称：</p>
            <input v-model="className" class="add_classinput_inp" placeholder="请输入班级名称" />
          </div>
          <div class="add_classinput" style="align-items: flex-start">
            <img class="add_classinput_img" src="../../assets/classManagement/cm8.png" style="margin-top: 12px" />
            <p class="add_classinput_txt" style="margin-top: -5px">表格上传：</p>
            <div style="position: relative">
              <img @click="btnClassImport" class="add_classinput_upload" src="../../assets/classManagement/cm7.png" />
              <div v-show="showResourcesFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
          <button @click="btnClassImportConfirm" class="add_classinput_btn">确认</button>
        </div>
      </div>
      <!-- 新增班级导入部分结束 -->
      <!-- 从班级库新增部分开始 -->
      <div class="add_class" v-if="classVisible">
        <div class="add_classbg"></div>
        <div class="add_classdiv">
          <p class="add_classtxt">新增班级</p>
          <img class="div_close btns" src="../../assets/classManagement/cm5.png" @click="classVisible = false" />
          <div class="gradediv">
            <div v-for="(item, index) in gradeDataList" @click="selectGrade(item)" :key="index" class="btns">
              <p v-if="item === gradeName" class="gradediv_color1">{{ item }}</p>
              <p v-else class="gradediv_color2">{{ item }}</p>
            </div>
          </div>
          <div class="gradediv-class">
            <div class="gradediv_class">
              <div v-for="(item, index) in classDataList" @click="selectClass(item.id)" :key="index"
                class="gradediv_classdiv btns">
                <img v-if="checkClassList.indexOf(item.id) !== -1" class="gradediv_classimg"
                  src="../../assets/classManagement/cm11.png" />
                <img v-else class="gradediv_classimg" src="../../assets/classManagement/cm10.png" />
                <p class="gradediv_classtxt">{{ item.name }}</p>
              </div>
            </div>
          </div>
          <button @click="btnConfirm('fromClassLibrary')" class="add_classinput_btn pointer">确认</button>
        </div>
      </div>
      <!-- 从班级库新增部分结束 -->
    </div>
    <div class="main-content" v-if="types === 2">
      <div class="gandtxt1">
        <p class="curriculum">班级</p>
        <el-select @change="nameHandleChange" class="top_input" placeholder="请选择" v-model="selectClassName" clearable>
          <el-option v-for="item in classTableData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
        <div class="flex align">
          <p class="curriculum">姓名</p>
          <el-input @change="searchName(nametxt)" class="top_input" placeholder="请输入姓名" v-model="nametxt"> </el-input>
          <img class="div_search btns" @click="searchName(nametxt)" src="../../assets/classManagement/cm13.png" />
        </div>
      </div>
      <div v-show="editableOrNot" class="gandtxt2">
        <img class="gandtxt_img2_1 btns" src="../../assets/classManagement/cm12.png" />
        <p class="gandtxt_txt2 btns" @click="add_people()">添加学生</p>
      </div>
      <!-- 学生表格部分开始 -->
      <el-table class="gandtable" :data="studentDataList"
        :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" height="581" border>
        <el-table-column align="center" label="学生名" prop="name"></el-table-column>
        <el-table-column align="center" label="学号" prop="account"></el-table-column>
        <el-table-column align="center" label="年级" prop="class.grade"></el-table-column>
        <el-table-column align="center" label="班级" prop="class.name"></el-table-column>
        <!-- <el-table-column v-if="editableOrNot" align="center" label="解除绑定">
          <template slot-scope="scope">
            <div @click="removeBinding(scope.row.id)" class="removeBinding pointer">解除微信绑定</div>
          </template>
        </el-table-column> -->
        <el-table-column v-if="editableOrNot" align="center" label="重置密码">
          <template slot-scope="scope"><img class="gandtable_btn3 btns" src="../../assets/classManagement/cm14.png"
              @click="resetPassword(scope.row)" /></template>
        </el-table-column>
        <el-table-column v-if="editableOrNot" align="center" label="删除">
          <template slot-scope="scope"><img class="gandtable_btn2 btns" src="../../assets/classManagement/cm4.png"
              @click="deleteStudent(scope.row.id)" /></template>
        </el-table-column>
      </el-table>
      <!-- 学生表格部分结束 -->
      <!-- 添加学生弹窗部分开始 -->
      <div class="add_class" v-if="peopleVisible">
        <div class="add_classbg"></div>
        <div class="add_classdiv" style="height: auto">
          <p class="add_classtxt">添加学生</p>
          <img class="div_close btns" src="../../assets/classManagement/cm5.png" @click="peopleVisible = false" />
          <div class="add_classinput" style="margin-top: 65px">
            <img class="add_classinput_img" src="../../assets/classManagement/cm8.png" />
            <p class="add_classinput_txt">学生学号：</p>
            <input v-model="studentAccount" class="add_classinput_inp" placeholder="请输入学生学号" />
          </div>
          <div class="add_classinput" style="margin-top: 20px">
            <img class="add_classinput_img" src="../../assets/classManagement/cm8.png" />
            <p class="add_classinput_txt">学生姓名：</p>
            <input v-model="studentName" class="add_classinput_inp" placeholder="请输入学生姓名" />
          </div>
          <div class="flex justify" style="margin-top: 50px; margin-bottom: 20px">
            <div @click="btnAddStudentDetermine" class="btnAddStudentDetermine pointer">确认</div>
          </div>
        </div>
      </div>
      <!-- 添加学生弹窗部分结束 -->
    </div>
    <!-- 重置密码删除学生弹窗部分开始 -->
    <div class="win_div" v-if="winVisible">
      <div class="win_divbg"></div>
      <div class="win_divdiv">
        <img class="div_close btns" src="../../assets/classManagement/cm5.png" @click="winVisible = false" />
        <p class="win_divtxt">{{ win_txt }}</p>
        <button @click="btnResetDelete" class="add_classinput_btn" style="bottom: 33px">确认</button>
      </div>
    </div>
    <!-- 重置密码删除学生弹窗部分结束 -->
  </div>
</template>

<script>
import axios from "axios";
import { obtainTeacherTeachingClass, studentList, gradeList, classOfGradeList, addTeacherTeachingClass, delTeacherTeachingClass, changeStudentPassword, addClassStudents, delClassStudents, clearBind } from "@/api";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import { Toast } from "vant";
import store from "@/store";
import md5 from "js-md5";
export default {
  name: "classManagement",
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      types: 1, //1是年级表，2是班级表
      page: 1, //页码
      count: 10, //条数
      countall: 0, //总条数
      add_classVisible: false, //新增班级导入弹窗
      gradeid: "2019级", //选中的年级
      classVisible: false, //从班级库新增弹窗
      win_txt: "", //弹窗内容
      winVisible: false, //是否显示弹窗
      nametxt: "", //搜索的姓名
      peopleVisible: false, //新增学生
      classTableData: [], // 老师授课班级列表
      gradeDataList: [], // 年级列表
      selectClassName: "", // 选择的班级名称
      checkGradeList: [], // 选择的年级列表
      className: "", // 班级名称
      showResourcesFormImport: false,
      studentFormSrc: "", // 学生表格Base64
      showPopoverGrade: false, // 控制班级列表下拉列表的显示
      loading: false, // 上传loading
      studentDataList: [], // 学生列表
      studentDataListRecord: [], // 学生记录列表
      gradeName: "", // 从班级库新增=>选中的年级
      checkClassList: [], // 选中的班级列表
      classDataList: [], // 年级对应的班级列表
      classID: "", // 班级id
      studentID: "", // 学生id
      studentAccount: "", // 学生学号
      studentName: "", // 学生姓名
      studentData: {}, // 学生数据
    };
  },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    // 调用获取老师授课班级列表接口
    let params = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params).then((res) => {
      this.classTableData = res.data.datas; // 获取老师授课班级列表
    });
    // 调用获取年级列表接口
    gradeList().then((res) => {
      this.gradeDataList = res.data.datas; // 获取年级列表
      this.gradeName = res.data.datas[0];
      // 调用获取对应年级的班级列表
      let params = { grade: res.data.datas[0] };
      classOfGradeList(params).then((res) => {
        this.classDataList = res.data.datas;
      });
    });
    // // 调用获取学生列表接口
    // let params1 = {
    //   where: [{ k: "account", v: "2200661", op: "=" }],
    // };
    // studentList(params1).then((res) => {});
  },
  methods: {
    //新增班级导入
    add_classes1() {
      this.add_classVisible = true;
    },
    // 从年级库新增
    add_classes2() {
      this.classVisible = true;
    },
    // 选择年级
    gradebtn(data) {
      this.gradeid = data.name;
    },
    // 添加学生
    add_people() {
      this.peopleVisible = true;
    },
    // 对应年级
    changeCheckbox(gradeName) {
      this.checkGradeList = [];
      this.checkGradeList.push(gradeName);
    },
    // 删除班级
    deleteClass(classID) {
      this.classID = classID;
      this.win_txt = "删除后此班级所有学生本课程的数据都会被清除，确定要删除吗？";
      this.winVisible = true;
    },
    // 新增班级导入=>表格上传
    btnClassImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.showResourcesFormImport = true;
          let file = event.target.files[0];
          // 文件流转Base64
          filetoBase64(file).then((base64) => {
            this.studentFormSrc = base64;
          });
        }
      };
    },
    // 班级导入确定按钮
    btnClassImportConfirm() {
      if (!this.checkGradeList[0]) {
        Toast("请选择对应年级！");
      } else if (!this.className) {
        Toast("请输入班级名称！");
      } else if (!this.studentFormSrc) {
        Toast("请上传表格！");
      } else {
        console.log(this.checkGradeList);
        this.loading = true;
        let formData = new FormData();
        let str1 = base64toFile(this.studentFormSrc, "file"); //base64图片格式转文件流
        formData.append("file", str1); // 加入文件流参数
        formData.append("grade", this.checkGradeList); // 加入年级名称参数
        formData.append("class_id", ""); // 加入班级id参数
        formData.append("class_name", this.className); // 加入班级名称参数
        axios
          .post(store.state.interfacePath + "api/import/account", formData, {
            headers: {
              "user-token": this.$store.state.loginRecord.data.ext,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let res = response.data;
            if (res.code == 0) {
              this.loading = false;
              this.add_classVisible = false;
              Toast("上传成功！");
              // 调用添加老师授课班级接口
              let data = { class_id: res.datas.id, lesson_id: this.$store.state.courseDetails.id };
              addTeacherTeachingClass(data).then((res) => {
                if (res.data.code == 0) {
                  // 调用获取老师授课班级列表接口
                  let params = { lesson_id: this.$store.state.courseDetails.id };
                  obtainTeacherTeachingClass(params).then((res) => {
                    this.classTableData = res.data.datas; // 获取老师授课班级列表
                  });
                }
              });
            } else {
              Toast(res.ext);
            }
          })
          .catch((response) => {
            console.log(response);
          });
      }
    },
    // 从班级库新增选择年级
    selectGrade(gradeName) {
      this.gradeName = gradeName;
      this.checkClassList = [];
      // 调用获取对应年级的班级列表
      let params = { grade: gradeName };
      classOfGradeList(params).then((res) => {
        this.classDataList = res.data.datas;
      });
    },
    // 从班级库新增选择班级
    selectClass(classId) {
      if (this.checkClassList.indexOf(classId) === -1) {
        this.checkClassList.push(classId);
      } else {
        this.checkClassList.splice(this.checkClassList.indexOf(classId), 1);
      }
    },
    // 确认按钮
    btnConfirm(source) {
      if (source == "fromClassLibrary") {
        if (this.checkClassList.length == 0) {
          Toast("请选择班级！");
        } else {
          let classId = "";
          for (let i in this.checkClassList) {
            classId += this.checkClassList[i] + ",";
          }
          let data = { class_id: classId, lesson_id: this.$store.state.courseDetails.id };
          addTeacherTeachingClass(data).then((res) => {
            if (res.data.code == 0) {
              this.classVisible = false;
              Toast("新增成功！");
              // 调用获取老师授课班级列表接口
              let params = { lesson_id: this.$store.state.courseDetails.id };
              obtainTeacherTeachingClass(params).then((res) => {
                this.classTableData = res.data.datas; // 获取老师授课班级列表
              });
            }
          });
        }
      }
    },
    // 班级查看详情
    classViewDetails(data) {
      console.log(data.id);
      this.classID = data.id; // 获取班级id
      this.selectClassName = data.name; // 获取选择班级名称
      // 调用获取学生列表接口
      let params = {
        where: [{ k: "class_id", v: data.id, op: "=" }],
      };
      studentList(params).then((res) => {
        this.studentDataList = res.data.datas; // 获取学生列表
        this.studentDataListRecord = res.data.datas;
      });
      this.types = 2;
    },
    // 解除微信绑定
    removeBinding(studentID) {
      this.studentID = studentID; // 获取学生id
      this.win_txt = "确定要将此学生的账号解除微信绑定吗？";
      this.winVisible = true;
    },
    // 打开重置密码弹窗
    resetPassword(data) {
      console.log(data)
      this.studentData = data; // 获取学生数据
      this.studentID = data.id; // 获取学生id
      this.win_txt = "确定要将此学生的密码重置为“YYykt+学生账号”的格式吗？";
      this.winVisible = true;
    },
    // 打开删除学生弹窗
    deleteStudent(studentID) {
      this.studentID = studentID; // 获取学生id
      this.win_txt = "确定要将此学生的账号删除吗？";
      this.winVisible = true;
    },
    // 重置密码、删除学生确定按钮
    btnResetDelete() {
      if (this.win_txt == "确定要将此学生的密码重置为“YYykt+学生账号”的格式吗？") {
        // 调用修改学生密码接口
        console.log("YYykt" + this.studentData.account)
        let data = { id: this.studentID, pwd: md5("YYykt" + this.studentData.account) };
        changeStudentPassword(data).then((res) => {
          if (res.data.code == 0) {
            this.winVisible = false;
            Toast("已重置为初始密码！");
          }
        });
      } else if (this.win_txt == "确定要将此学生的账号删除吗？") {
        // 调用删除学生接口
        let data = { id: this.studentID };
        delClassStudents(data).then((res) => {
          if (res.data.code == 0) {
            this.winVisible = false;
            Toast("已删除！");
            // 调用获取学生列表接口
            let params = {
              where: [{ k: "class_id", v: this.classID, op: "=" }],
            };
            studentList(params).then((res) => {
              this.studentDataList = res.data.datas; // 获取学生列表
              this.studentDataListRecord = res.data.datas;
            });
          }
        });
      } else if (this.win_txt == "删除后此班级所有学生本课程的数据都会被清除，确定要删除吗？") {
        // 调用删除老师授课班级接口
        let data = { class_id: this.classID, lesson_id: this.$store.state.courseDetails.id };
        delTeacherTeachingClass(data).then((res) => {
          if (res.data.code == 0) {
            this.winVisible = false;
            Toast("已删除！");
            // 调用获取老师授课班级列表接口
            let params = { lesson_id: this.$store.state.courseDetails.id };
            obtainTeacherTeachingClass(params).then((res) => {
              this.classTableData = res.data.datas; // 获取老师授课班级列表
            });
          }
        });
      } else if (this.win_txt == "确定要将此学生的账号解除微信绑定吗？") {
        // 调用清空用户绑定接口
        let data = { user_id: this.studentID };
        clearBind(data).then((res) => {
          if (res.data.code == 0) {
            this.winVisible = false;
            Toast("已解除绑定！");
          }
        });
      }
    },
    // 添加学生确定按钮
    btnAddStudentDetermine() {
      if (this.studentAccount == "") {
        Toast("请输入学生学号！");
      } else if (this.studentName == "") {
        Toast("请输入学生姓名！");
      } else {
        let data = {
          account: this.studentAccount,
          name: this.studentName,
          state: 1,
          identity: "student",
          class_id: this.classID,
          pwd: md5("YYykt" + this.studentAccount),
        };
        addClassStudents(data).then((res) => {
          this.peopleVisible = false;
          Toast("已添加！");
          // 调用获取学生列表接口
          let params = {
            where: [{ k: "class_id", v: this.classID, op: "=" }],
          };
          studentList(params).then((res) => {
            this.studentDataList = res.data.datas; // 获取学生列表
            this.studentDataListRecord = res.data.datas;
          });
        });
      }
    },
    // 上传学生模板下载
    templateDownload() {
      var a = document.createElement("a"); // 创建一个新的<a>标签
      a.href = window.location.protocol + "//school.striveing.com/web/template/学生账号导入模板.xlsx"; // 设置<a>标签的herf属性
      a.download = "学生账号导入模板.xlsx"; // 设置下载后的文件名称
      document.body.appendChild(a); // 将 <a> 元素添加到 <body> 元素的末尾
      a.click();
    },
    // 班级选择器切换学生列表
    nameHandleChange(value) {
      // 调用获取学生列表接口
      if (!value) return;
      let params = {
        where: [{ k: "class_id", v: value, op: "=" }],
      };
      studentList(params).then((res) => {
        this.studentDataList = res.data.datas; // 获取学生列表
        this.studentDataListRecord = res.data.datas;
      });
    },
    // 姓名输入框搜索
    searchName(name) {
      this.studentDataList = [];
      for (let i = 0; i < this.studentDataListRecord.length; i++) {
        if (this.studentDataListRecord[i].name.indexOf(name) >= 0) {
          this.studentDataList.push(this.studentDataListRecord[i]);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
p {

  font-weight: 400;
}

.btns {
  cursor: pointer;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.gandtxt1 {
  padding-top: 30px;
  display: flex;
}

.curriculum {
  margin-left: 60px;
  font-size: 24px;
  line-height: 40px;
}

.top_input {
  width: 200px;
  height: 40px;
  margin-left: 10px;
  border-radius: 10px;
}

.gandtxt2 {
  display: flex;
  justify-content: flex-end;
  height: 20px;
  align-items: center;
}

.gandtxt_img2_1 {
  width: 20px;
  height: 16px;
}

.gandtxt_img2_2 {
  width: 20px;
  height: 18px;
}

.gandtxt_txt2 {
  margin-left: 10px;
  margin-right: 30px;
  font-size: 18px;
  color: #349afe;
}

.gandtable {
  margin-top: 20px;
}

.gandhand {
  margin-top: 30px;
  margin-left: 60px;
  padding-bottom: 30px;
}

.gandtable_btn1 {
  width: 107px;
  height: 19px;
}

.gandtable_btn2 {
  width: 68px;
  height: 20px;
}

.add_class {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.add_classbg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
}

.add_classdiv {
  width: 760px;
  height: 430px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.add_classtxt {
  font-size: 26px;
  color: #349afe;
  line-height: 23px;
  margin-top: 24px;
}

.div_close {
  width: 23px;
  height: 23px;
  position: absolute;
  top: 24px;
  right: 24px;
}

.add_classtemp {
  width: 107px;
  height: 19px;
  position: absolute;
  top: 74px;
  left: 590px;
}

.add_classinput {
  display: flex;
  margin-top: 20px;
  margin-left: 60px;
  align-items: center;
}

.add_classinput_img {
  width: 10px;
  height: 10px;
  margin-top: -6px;
}

.add_classinput_txt {
  font-size: 22px;
  color: #555555;
  line-height: 50px;
  margin-left: 5px;
  margin-right: 20px;
}

.add_classinput_inp {
  width: 490px;
  height: 50px;
  border: 1px solid #757575;
  box-sizing: border-box;
  border-radius: 10px;
  padding-left: 17px;
  font-size: 20px;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.selectClass-box {
  width: 490px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: scroll;
}

.add_classbtn {
  width: 14px;
  height: 14px;
  position: absolute;
  left: 650px;
}

.add_classinput_upload {
  width: 135px;
  height: 95px;
}

.add_classinput_btn {
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 50%;
  margin-left: -100px;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  border: 0 solid #757575;
  text-align: center;
  font-size: 28px;
  line-height: 50px;
  color: #ffffff;
}

.gradediv {
  width: 100%;
  height: 50px;
  margin-top: 34px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
  overflow: hidden;
  overflow-x: scroll;
  white-space: nowrap;
}

.gradediv_color1 {
  color: #349afe;
}

.gradediv_color2 {
  color: #000000;
}

.gradediv-class {
  height: 250px;
  overflow: scroll;
}

.gradediv_class {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  margin-top: 5px;
  margin-left: 33px;
}

.gradediv_classdiv {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-bottom: 33px;
  margin-right: 44px;
}

.gradediv_classimg {
  width: 20px;
  height: 20px;
}

.gradediv_classtxt {
  font-size: 18px;
  font-weight: 400;
  color: #555555;
  margin-left: 10px;
}

.win_div {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.win_divbg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.5;
}

.win_divdiv {
  width: 760px;
  height: 300px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 50%;
  margin-top: -150px;
  left: 50%;
  margin-left: -380px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.win_divtxt {
  width: 450px;
  font-size: 30px;
  color: #000000;
  margin-bottom: 70px;
}

.div_search {
  position: absolute;
  width: 20px;
  height: 20px;
  margin-left: 281px;
}

.gandtable_btn3 {
  width: 160px;
  height: 22px;
}

.btnAddStudentDetermine {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
}

.submitSuccessfully {
  position: absolute;
  top: 0;
  width: 135px;
  height: 95px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.submitSuccessfullyImg {
  width: 40px;
  height: 40px;
}

.removeBinding {

  font-weight: 400;
  font-size: 18px;
  color: #349afe;
}
</style>
